import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { RefObject } from 'react';

const alliances = [
  { name: 'Cyprus Securities and Exchange Commission', abbr: 'CySEC' },
  { name: 'Institute of Certified Public Accountants', abbr: 'ICPAC' },
  { name: 'Cyprus Bar Association', abbr: 'CBA' },
  { name: 'European Banking Authority', abbr: 'EBA' },
];

export default function Alliances() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="py-16 lg:py-20 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div
          ref={ref as RefObject<HTMLDivElement>}
          className={`text-center mb-12 lg:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl lg:text-5xl font-semibold text-slate-900 leading-tight">
            Our Alliances, Memberships and Affiliations
          </h2>
        </div>

        {/* Scrolling Logos */}
        <div className="relative">
          <div className="absolute left-0 top-0 w-20 h-full bg-gradient-to-r from-slate-50 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 w-20 h-full bg-gradient-to-l from-slate-50 to-transparent z-10 pointer-events-none"></div>

          <div className="flex animate-scroll-infinite">
            {[...alliances, ...alliances, ...alliances].map((alliance, index) => (
              <div key={index} className="flex-shrink-0 w-[280px] lg:w-[300px] px-4">
                <div className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 w-full h-[220px] lg:h-[260px] flex flex-col justify-center items-center p-6">
                  <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-slate-700">{alliance.abbr}</span>
                  </div>
                  <p className="text-center text-slate-900 font-medium text-sm">{alliance.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll-infinite {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-infinite {
          animation: scroll-infinite 30s linear infinite;
        }
        .animate-scroll-infinite:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
